class PDPProductOverviewQuantityInput extends HTMLElement {
  constructor() {
    super();
  }

  /**
   * Called when the element is inserted into the DOM.
   * Initializes event listeners for the quantity input buttons.
   */
  connectedCallback() {
    this.subtractBtn = this.querySelector(".product__quantity-subtract-item");
    this.addBtn = this.querySelector(".product__quantity-add-item");
    this.quantityInput = this.querySelector(".quantity-input__input");

    this.subtractBtn.addEventListener(
      "click",
      this.subtractQuantity.bind(this)
    );

    this.addBtn.addEventListener("click", this.addQuantity.bind(this));
  }

  /**
   * Called when the element is removed from the DOM.
   * Removes event listeners to prevent memory leaks.
   */
  disconnectedCallback() {
    this.subtractBtn.removeEventListener(
      "click",
      this.subtractQuantity.bind(this),
      true
    );

    this.addBtn.removeEventListener("click", this.addQuantity.bind(this), true);
  }

  /**
   * Handles the click event on the subtract button to decrease the quantity.
   * @param {Event} event - The click event.
   */
  subtractQuantity(event) {
    const btn = event.target.closest(".product__quantity-subtract-item");
    if (!btn) return;
    const currentQty = +this.getCurrentQuantity();
    if (currentQty === 1) return;
    this.setQuantity(currentQty - 1);
  }

  /**
   * Handles the click event on the add button to increase the quantity.
   * @param {Event} event - The click event.
   */
  addQuantity(event) {
    const btn = event.target.closest(".product__quantity-add-item");
    if (!btn) return;
    const currentQty = +this.getCurrentQuantity();
    this.setQuantity(currentQty + 1);
  }

  /**
   * Retrieves the current quantity from the input field.
   * @returns {string} The current quantity.
   */
  getCurrentQuantity() {
    return this.quantityInput.value;
  }

  /**
   * Sets the quantity in the input field.
   * @param {number} qty - The quantity to set.
   */
  setQuantity(qty) {
    this.quantityInput.value = qty;
  }
}

customElements.define(
  "pdp-product-overview-quantity-input",
  PDPProductOverviewQuantityInput
);
